import React from "react";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { Divider } from "@material-ui/core";


const useStyles = makeStyles(()=>({
    paper:{
        borderRadius: 0,
        backgroundColor: "#ED2024",
        color: "#FFF",
    },
    list: {
        paddingTop: 0,
        paddingBottom: 0
    },
    listItem: {
        fontSize: ".8em"
    },
    divider:{
        backgroundColor: "#fff",
        opacity: ".5",
    },
    button:{
        "&:hover": {
            backgroundColor: "#800000"
          }
    }

}))

 
 
 
 
 

const linkData = [
    { 
      url: "https://negocios.aceservices.accenture.com/negocios/#/identificacao",
      text: "VIVERE"
    },
    {
      url: "https://www.santander.com.br/hotsite/santanderfinanciamentos/banco-do-auto.html?int_source=menu-financiamento&ori=SF",
      text: "FINONLINE"
    },
    {
      url: "https://brpioneer.accenture.com/originacao-auto/login",
      text: "PIONEER"
    },
    {
      url: "https://www.consultormaisturbo.com.br/login",
      text: "Mesa de Suporte - Ajustes códigos"
    },
    {
      url: "https://santandernet-my.sharepoint.com.mcas.ms/:x:/r/personal/t783828_santander_com_br/_layouts/15/Doc.aspx?sourcedoc=%7B708B03DA-31B2-4BF7-A904-36FB9059DD6F%7D&file=calculadora%20S4F%20compartilhada.xlsx&fromShare=true&action=default&mobileredirect=true",
      text: "Calculadora"
    }
]

function FinanciamentoSubMenu(props){
    const {anchor, open, handleClose} = props;
    const classes = useStyles()

    return (
        <Popper id="popper" open={open} anchorEl={anchor.current} role={undefined} transition disablePortal placement={"bottom"}>
          {({ TransitionProps}) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: 'left top', left:"5px"}}
            >
              <Paper elevation={0} classes={{root: classes.paper}}>
                <ClickAwayListener onClickAway={()=>handleClose(false)}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" classes={{root: classes.list}}>
                    {linkData.map((e, i, a)=>
                    [<MenuItem key={e.text} ListItemClasses={{button: classes.button}} component="a" href={e.url} target="_blank" classes={{root: classes.listItem}} >
                        {e.text}
                        </MenuItem>,
                    i < a.length-1 && <Divider key={"divider-"+i} classes={{root: classes.divider}}  component="li" />
                    ]
                    
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>

    )
}

export { FinanciamentoSubMenu }